import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

// JWT decode library
import { jwtDecode } from 'jwt-decode';

// Bootstrap components
import { Row, Col, Breadcrumb } from 'react-bootstrap';

// RSuite components (จัดกลุ่มและเลือกเฉพาะที่ใช้จริง)
import {
    Panel, Table, Pagination, Button, IconButton, ButtonToolbar,
    Tooltip, Whisper, MultiCascader, HStack, VStack,
    SelectPicker, Input, InputNumber, InputGroup, Text, Tabs, Placeholder,
    Modal, Container, Toggle, Loader
} from 'rsuite';

// SweetAlert2 for alerts
import Swal from 'sweetalert2';

export default class ApplicantPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            modal: null,
            table: false,
            loading: false,
            isOpen: true,
            data: [],
            sortColumn: '',
            sortType: '',
            loading: false,
            limit: 20,
            page: 1,
            yearData: [],
            defaultYear: null,
            rightData: [
                { label: 'สิทธิ์ที่ 1', value: 'Rights1' }
                , { label: 'สิทธิ์ที่ 2', value: 'Rights2' }
                , { label: 'สิทธิ์ที่ 3', value: 'Rights3' }
                , { label: 'สิทธิ์ที่ 4', value: 'Rights4' }
            ],
            villageData: [],
            schoolData: [],
            statusData: [
                { label: 'สอบติดเรียบร้อยและยืนยันการเข้าเรียน', value: 'สอบติดเรียบร้อยและยืนยันการเข้าเรียน' }
                , { label: 'สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน', value: 'สอบติดเรียบร้อยแต่ยังไม่ได้ยืนยันการเข้าเรียน' }
                , { label: 'รอผลประกาศการสอบเข้า', value: 'รอผลประกาศการสอบเข้า' }
                , { label: 'ยังไม่ได้ดำเนินการสอบ', value: 'ยังไม่ได้ดำเนินการสอบ' }
            ],
            villageApplicant: '',
            schoolApplicant: '',
            rightApplicant: '',
            statusApplicant: '',
            decisionApplicant: '',
            queryApplicant: '',
            decision_result: 0,
            cost_of_living: '',
            tuition_fee: '',
            dormitory: '',
            registration: '',
            committee1_result: 0,
            committee1_comment: '',
            committee2_result: 0,
            scoringCriteria: [],
            committeeList_1: [],
            committeeList_2: [],
            orderDataGroup1: [],
            orderDataGroup2: []
        };
    }

    async componentDidMount() {
        const token = localStorage.getItem('token');

        if (!token) {
            // ไม่มี token ให้ไปหน้า login
            return window.location.href = '/admin/login';
        }

        try {
            // Decode token เพื่อตรวจสอบ expire time
            const decoded = jwtDecode(token);
            const currentTime = Date.now() / 1000;

            if (decoded.exp < currentTime) {
                // token หมดอายุ
                localStorage.removeItem('token');
                return window.location.href = '/admin/login';
            }

            const authHeader = {
                headers: { Authorization: `Bearer ${token}` }
            };

            await this.promisedSetState({ authHeader });

            // เรียก API หลังตรวจสอบ token แล้ว
            const response = await axios.get(`${process.env.REACT_APP_API}/status/1`, authHeader);
            await this.promisedSetState({ defaultYear: response.data[0]?.default_year });
            await this.onRenderContent({ mode: 'read' });

        } catch (error) {
            console.error('Error during token validation or API call:', error);
            localStorage.removeItem('token');
            window.location.href = '/admin/login';
        }
    }

    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    to2decimal = (value) => {
        return `${(value * 1).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    toInterger = (value) => {
        return `${(value * 1).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    fetchYearData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/years`, this.state.authHeader);
            const formattedData = response.data.map(year => ({
                value: year.year_name,
                label: year.year_name
            }));
            await this.promisedSetState({ yearData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchYearData data' });
        }
    };

    fetchVillageData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/villages`, this.state.authHeader);
            const formattedData = response.data.map(data => ({
                value: data.name,
                label: data.name
            }));
            await this.promisedSetState({ villageData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchVillageData data' });
        }
    };

    fetchSchoolData = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API}/schools`, this.state.authHeader);
            const formattedData = response.data.map(data => ({
                value: data.name,
                label: data.name
            }));

            // Add "อื่นๆ" as the last option
            formattedData.push({
                label: 'อื่นๆ',  // Label for the "Others" option
                value: 'อื่นๆ'   // Value for the "Others" option
            });

            await this.promisedSetState({ schoolData: formattedData });
        } catch (err) {
            console.log({ error: 'Failed to load fetchSchoolData data' });
        }
    };

    calculateAge = (date_of_birth) => {
        const birthDate = new Date(date_of_birth);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const month = today.getMonth() - birthDate.getMonth();

        if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age;
    }

    handleSortColumn = async (sortColumn, sortType) => {
        // เปิด loading
        await this.promisedSetState({ loading: true });

        // clone data ปัจจุบันเพื่อจัดเรียง
        let sortedData = [...this.state.data];

        sortedData.sort((a, b) => {
            let x = a[sortColumn];
            let y = b[sortColumn];

            // ตัวเลข
            if (!isNaN(x) && !isNaN(y)) {
                x = Number(x);
                y = Number(y);
            }

            // string → lowercase เพื่อเทียบได้
            if (typeof x === "string") x = x.toLowerCase();
            if (typeof y === "string") y = y.toLowerCase();

            if (sortType === "asc") {
                return x > y ? 1 : -1;
            } else {
                return x < y ? 1 : -1;
            }
        });

        // ตั้งค่า sort และอัปเดต data
        await this.promisedSetState({
            sortColumn,
            sortType,
            data: sortedData
        });

        // แกล้ง delay นิดหน่อยเพื่อ UX
        await new Promise(resolve => setTimeout(resolve, 300));

        // ปิด loading
        await this.promisedSetState({ loading: false });

        // หลัง sort เสร็จ — เรียก render content ใหม่ (ถ้าต้องการ)
        await this.onRenderContent({ mode: "read" });
    };

    getData = async () => {
        if (this.state.sortColumn && this.state.sortType) {
            return this.state.data.sort((a, b) => {
                let x = a[this.state.sortColumn];
                let y = b[this.state.sortColumn];
                if (typeof x === 'string') {
                    x = x.charCodeAt();
                }
                if (typeof y === 'string') {
                    y = y.charCodeAt();
                }
                if (this.state.sortType === 'asc') {
                    return x - y;
                } else {
                    return y - x;
                }
            });
        }

        return this.state.data.filter((v, i) => {
            const start = this.state.limit * (this.state.page - 1);
            const end = start + this.state.limit;
            return i >= start && i < end;
        });
    };

    handleToggle = () => {
        this.setState(prevState => ({ isOpen: !prevState.isOpen }), () => {
            // เรียกใช้งาน callback หลัง toggle
            this.onRenderContent({ mode: 'read' });
        });
    };

    onRenderContent = async ({ mode }) => {
        if (mode === 'read') {
            try {

                const { Column, HeaderCell, Cell } = Table;

                await this.promisedSetState({ loading: true }); // Set loading state

                await this.fetchYearData()
                await this.fetchVillageData()
                await this.fetchSchoolData()

                const responseApplicant = await axios.post(`${process.env.REACT_APP_API}/application/years`, {
                    year: this.state.defaultYear,
                    village: this.state.villageApplicant,
                    school: this.state.schoolApplicant,
                    right: this.state.rightApplicant,
                    status: this.state.statusApplicant,
                    decision: this.state.decisionApplicant,
                    query: this.state.queryApplicant
                }, this.state.authHeader);

                // ดึงข้อมูลโหวตครบหรือยัง ทีละคน
                const data = await Promise.all(responseApplicant.data.map(async (applicant, index) => {
                    const res = await axios.get(
                        `${process.env.REACT_APP_API}/application/check-committee/${this.state.defaultYear}/${applicant.id}`,
                        this.state.authHeader
                    );

                    const votingData = res.data;

                    const group1 = votingData.groups?.group1 || {};
                    const group2 = votingData.groups?.group2 || {};

                    return {
                        index: index + 1,
                        id: applicant.id,
                        applicant_id: applicant.applicant_id,
                        prefix: applicant.prefix,
                        name: `${applicant.first_name} ${applicant.last_name} ${applicant.decision_result
                            ? `<i class="bi bi-check-circle-fill" style="font-size: 1rem; color: green;"></i>`
                            : ''}`,
                        nickname: applicant.nickname,
                        age: this.calculateAge(applicant.date_of_birth),
                        village: applicant.reg_village === 'other'
                            ? applicant.reg_village_name
                            : applicant.reg_village,
                        school: applicant.next_institution,
                        status: applicant.app_status,
                        tel: applicant.phone,
                        committee1_result: applicant.committee1_result,

                        // ⭐⭐ เพิ่ม field สำหรับ sorting คะแนนเฉลี่ย ⭐⭐
                        averageScore: group1.averageScore ?? null,
                        averageScoreGroup1: group1.averageScore ?? null,
                        averageScoreGroup2: group2.averageScore ?? null,

                        voting: {
                            group1: {
                                total: group1.total || 0,
                                votedCount: group1.votedCount || 0,
                                averageScore: group1.averageScore ?? null,
                                isComplete: group1.isComplete || false
                            },
                            group2: {
                                total: group2.total || 0,
                                votedCount: group2.votedCount || 0,
                                averageScore: group2.averageScore ?? null,
                                isComplete: group2.isComplete || false
                            }
                        },

                        data: applicant
                    };
                }));

                await this.promisedSetState({ data: data });

                const paginatedData = await this.getData();

                // โหลดกลุ่ม 1
                const res1 = await axios.get(
                    `${process.env.REACT_APP_API}/committee-order/${this.state.defaultYear}/1`,
                    this.state.authHeader
                );

                let group1Data = [];
                if (res1.data?.order) {
                    try {
                        group1Data = typeof res1.data.order === 'string'
                            ? JSON.parse(res1.data.order)
                            : Array.isArray(res1.data.order)
                                ? res1.data.order
                                : [];
                    } catch (err) {
                        group1Data = [];
                    }
                }

                // โหลดกลุ่ม 2
                const res2 = await axios.get(
                    `${process.env.REACT_APP_API}/committee-order/${this.state.defaultYear}/2`,
                    this.state.authHeader
                );

                let group2Data = [];
                if (res2.data?.order) {
                    try {
                        group2Data = typeof res2.data.order === 'string'
                            ? JSON.parse(res2.data.order)
                            : Array.isArray(res2.data.order)
                                ? res2.data.order
                                : [];
                    } catch (err) {
                        group2Data = [];
                    }
                }

                // อัปเดต state
                await this.promisedSetState({
                    orderDataGroup1: group1Data,
                    orderDataGroup2: group2Data
                });

                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>ข้อมูลผู้สมัคร</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Row className="mb-3" style={{ alignItems: 'center', gap: '16px', flexWrap: 'wrap' }}>
                                    {/* ปีการศึกษา */}
                                    <Col lg={2} md={4} sm={12} style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                        <label style={{ fontWeight: 600 }}>ปีการศึกษา</label>
                                        <SelectPicker
                                            size="lg"
                                            data={this.state.yearData}
                                            searchable={false}
                                            cleanable={false}
                                            placeholder="กรุณาเลือก"
                                            defaultValue={this.state.defaultYear}
                                            style={{ width: '110px' }}
                                            onSelect={async (v, i) => {
                                                await this.promisedSetState({ defaultYear: v });
                                                this.onRenderContent({ mode: 'read' });
                                            }}
                                        />
                                    </Col>

                                    {/* Search + ปุ่มค้นหา */}
                                    <Col lg={4} md={6} sm={12} style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                        <InputGroup size="lg" style={{ flex: 1, minWidth: '200px' }}>
                                            <InputGroup.Addon>
                                                <i className="bi bi-search"></i>
                                            </InputGroup.Addon>
                                            <Input
                                                onChange={e => this.setState({ queryApplicant: e })}
                                                onKeyDown={async e => {
                                                    if (e.key === 'Enter') {
                                                        await this.promisedSetState({ page: 1 });
                                                        this.onRenderContent({ mode: 'read' });
                                                    }
                                                }}
                                            />
                                        </InputGroup>

                                        <Button
                                            size="md"
                                            appearance="primary"
                                            onClick={async () => {
                                                await this.promisedSetState({ page: 1 });
                                                this.onRenderContent({ mode: 'read' });
                                            }}
                                        >
                                            ค้นหา
                                        </Button>
                                    </Col>

                                    {/* Toggle ตัวกรอง */}
                                    <Col lg={2} md={4} sm={6} style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                                        <Toggle size="md" checked={this.state.isOpen} onChange={this.handleToggle} />
                                        <Text muted>ตัวกรอง</Text>
                                    </Col>

                                    {/* ปุ่มกำหนดคณะกรรมการ */}
                                    <Col lg={3} md={6} sm={12} style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                                        <div
                                            onClick={() => this.onModalCriteria({ mode: 'setting' })}
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                                padding: '6px 12px',
                                                borderRadius: '6px',
                                                background: 'linear-gradient(135deg, #6f42c1, #8b5cf6)',
                                                color: '#fff',
                                                fontWeight: 500,
                                                cursor: 'pointer',
                                                transition: 'all 0.2s ease'
                                            }}
                                            onMouseEnter={e => {
                                                e.currentTarget.style.transform = 'translateY(-1px)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(111,66,193,0.25)';
                                            }}
                                            onMouseLeave={e => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 2px 6px rgba(111,66,193,0.2)';
                                            }}
                                        >
                                            <i className="bi bi-people-fill"></i>
                                            <span>กำหนดคณะกรรมการ/เกณฑ์ตัดสิน</span>
                                            <i className="bi bi-arrow-right-short"></i>
                                        </div>
                                    </Col>
                                </Row>

                                {this.state.isOpen && (
                                    <div
                                        style={{
                                            border: '1px dashed #ccc', // เส้นประสีเทา
                                            borderRadius: '8px',        // มุมโค้งนิดหน่อย
                                            padding: '8px',            // เว้นระยะขอบ
                                            marginBottom: '8px'        // เว้นระยะจาก element ด้านล่าง
                                        }}
                                    >
                                        <>
                                            <Row>
                                                <Col lg={3} className='mb-1'>
                                                    <VStack>
                                                        <label>หมู่บ้าน</label>
                                                        <SelectPicker size='md'
                                                            data={this.state.villageData}
                                                            placeholder='กรุณาเลือก'
                                                            style={{ width: '100%' }}
                                                            onSelect={async (v, i) => {
                                                                await this.promisedSetState({ villageApplicant: v })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                            onClean={async () => {
                                                                await this.promisedSetState({ villageApplicant: '' })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                        />
                                                    </VStack>
                                                </Col>
                                                <Col lg={4} className='mb-1'>
                                                    <VStack>
                                                        <label>สถานศึกษาเรียนต่อ</label>
                                                        <SelectPicker size='md'
                                                            data={this.state.schoolData}
                                                            placeholder='กรุณาเลือก'
                                                            style={{ width: '100%' }}
                                                            onSelect={async (v, i) => {
                                                                await this.promisedSetState({ schoolApplicant: v })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                            onClean={async () => {
                                                                await this.promisedSetState({ schoolApplicant: '' })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                        />
                                                    </VStack>
                                                </Col>
                                                <Col lg={5} className='mb-1'>
                                                    <VStack>
                                                        <label>สิทธิ์การสมัคร</label>
                                                        <MultiCascader size='md'
                                                            data={this.state.rightData}
                                                            placeholder='กรุณาเลือก'
                                                            style={{ minWidth: '100%' }}
                                                            onChange={async e => {
                                                                await this.promisedSetState({ rightApplicant: e })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                            onClean={async () => {
                                                                await this.promisedSetState({ rightApplicant: '' })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                        />
                                                    </VStack>
                                                </Col>
                                            </Row>

                                            <Row className='mb-3'>
                                                <Col className='mb-1' lg={4}>
                                                    <VStack>
                                                        <label>สถานะการสมัครเรียนในมหาวิทยาลัย</label>
                                                        <SelectPicker size='md'
                                                            data={this.state.statusData}
                                                            placeholder='กรุณาเลือก'
                                                            style={{ width: '100%' }}
                                                            onSelect={async (v, i) => {
                                                                await this.promisedSetState({ statusApplicant: v })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                            onClean={async () => {
                                                                await this.promisedSetState({ statusApplicant: '' })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                        />
                                                    </VStack>
                                                </Col>
                                                <Col lg={2}>
                                                    <VStack>
                                                        <label>สถานะการคัดเลือก</label>
                                                        <SelectPicker size='md'
                                                            data={[{ label: 'ผ่าน', value: true }, { label: 'ไม่ผ่าน', value: false }]}
                                                            placeholder='กรุณาเลือก'
                                                            style={{ width: '100%' }}
                                                            onSelect={async (v, i) => {
                                                                await this.promisedSetState({ decisionApplicant: v })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                            onClean={async () => {
                                                                await this.promisedSetState({ decisionApplicant: '' })
                                                                await this.onRenderContent({ mode: 'read' })
                                                            }}
                                                        />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                        </>
                                    </div>
                                )}

                                <Row className='mt-3'>
                                    <Col>
                                        <Tabs defaultActiveKey="1" appearance="subtle">
                                            <Tabs.Tab eventKey="1" title={
                                                <><i className="bi bi-people-fill me-2" style={{ color: '#3b82f6' }}></i>ข้อมูลผู้สมัคร</>
                                            } >
                                                <Table
                                                    autoHeight
                                                    data={paginatedData}
                                                    bordered
                                                    cellBordered
                                                    sortColumn={this.state.sortColumn}
                                                    sortType={this.state.sortType}
                                                    onSortColumn={this.handleSortColumn}
                                                    className="shadow-sm"
                                                >

                                                    <Column width={50} align="center">
                                                        <HeaderCell>ลำดับ</HeaderCell>
                                                        <Cell dataKey="index" />
                                                    </Column>

                                                    <Column width={80} resizable>
                                                        <HeaderCell>คำนำหน้า</HeaderCell>
                                                        <Cell dataKey="prefix" />
                                                    </Column>

                                                    <Column width={185} resizable>
                                                        <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
                                                        <Cell>
                                                            {rowData => (
                                                                <span dangerouslySetInnerHTML={{ __html: rowData.name }} />
                                                            )}
                                                        </Cell>
                                                    </Column>

                                                    <Column width={80}>
                                                        <HeaderCell>ชื่อเล่น</HeaderCell>
                                                        <Cell dataKey="nickname" />
                                                    </Column>

                                                    <Column width={55} resizable>
                                                        <HeaderCell>อายุ</HeaderCell>
                                                        <Cell dataKey="age" />
                                                    </Column>

                                                    <Column width={120} resizable>
                                                        <HeaderCell>เบอร์โทรศัพท์</HeaderCell>
                                                        <Cell dataKey="tel" />
                                                    </Column>

                                                    <Column width={135} resizable>
                                                        <HeaderCell>หมู่บ้าน</HeaderCell>
                                                        <Cell dataKey="village" />
                                                    </Column>

                                                    <Column width={195} resizable>
                                                        <HeaderCell>สถานศึกษาเรียนต่อ</HeaderCell>
                                                        <Cell dataKey="school" />
                                                    </Column>

                                                    <Column width={255} resizable>
                                                        <HeaderCell>สถานะการสมัครเรียน</HeaderCell>
                                                        <Cell dataKey="status" />
                                                    </Column>

                                                    {/* คอลัมน์ปุ่มจัดการ */}
                                                    <Column width={185} fixed="right" align="center">
                                                        <HeaderCell>...</HeaderCell>
                                                        <Cell style={{ padding: '4px' }}>
                                                            {rowData => (
                                                                <ButtonToolbar>
                                                                    <Whisper followCursor speaker={<Tooltip>ดูรายละเอียด</Tooltip>}>
                                                                        <a
                                                                            href={`/admin/applicant/detail/${rowData.id}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            <IconButton
                                                                                size="xs"
                                                                                color="blue"
                                                                                appearance="primary"
                                                                                icon={<i className="bi bi-file-earmark-text"></i>}
                                                                            />
                                                                        </a>
                                                                    </Whisper>

                                                                    <Whisper followCursor speaker={<Tooltip>คัดเลือก</Tooltip>}>
                                                                        <IconButton
                                                                            size="xs"
                                                                            color="green"
                                                                            appearance="primary"
                                                                            icon={<i className="bi bi-person-check"></i>}
                                                                            onClick={() =>
                                                                                this.onModalEdit({ mode: 'consider', id: rowData.id })
                                                                            }
                                                                        />
                                                                    </Whisper>

                                                                    <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                        <a
                                                                            href={`/admin/applicant/edit/${rowData.id}`}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            <IconButton
                                                                                size="xs"
                                                                                color="yellow"
                                                                                appearance="primary"
                                                                                icon={<i className="bi bi-pencil-square"></i>}
                                                                            />
                                                                        </a>
                                                                    </Whisper>

                                                                    <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                        <IconButton
                                                                            size="xs"
                                                                            color="red"
                                                                            appearance="primary"
                                                                            icon={<i className="bi bi-trash-fill"></i>}
                                                                            onClick={() =>
                                                                                this.onConfirm({ mode: 'delete', id: rowData.id })
                                                                            }
                                                                        />
                                                                    </Whisper>
                                                                </ButtonToolbar>
                                                            )}
                                                        </Cell>
                                                    </Column>
                                                </Table>

                                                <div style={{ padding: 20 }}>
                                                    <Pagination
                                                        prev
                                                        next
                                                        first
                                                        last
                                                        ellipsis
                                                        boundaryLinks
                                                        maxButtons={5}
                                                        size="xs"
                                                        layout={['total', '|', 'pager']}
                                                        total={data.length}
                                                        limit={this.state.limit}
                                                        activePage={this.state.page}
                                                        onChangePage={async (e) => {
                                                            await this.promisedSetState({ page: e }); // Update current page
                                                            this.onRenderContent({ mode: 'read' }); // Fetch new data based on page
                                                        }}
                                                    />
                                                </div>
                                            </Tabs.Tab>
                                            <Tabs.Tab eventKey="2" title={
                                                <><i className="bi bi-bar-chart-line-fill me-2" style={{ color: '#f59e0b' }}></i>ตารางคะแนน</>
                                            } >
                                                <Tabs
                                                    defaultActiveKey="1"
                                                    style={{
                                                        backgroundColor: '#f9f9f9',
                                                        borderRadius: '10px',
                                                        padding: '10px',
                                                        boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
                                                    }}>
                                                    <Tabs.Tab eventKey="1" title={<><i className="bi bi-person-lines-fill" style={{ marginRight: '6px' }}></i>คณะกรรมการชุดที่ 1</>}>

                                                        <Table
                                                            autoHeight
                                                            data={this.state.data}
                                                            bordered
                                                            cellBordered
                                                            sortColumn={this.state.sortColumn}
                                                            sortType={this.state.sortType}
                                                            onSortColumn={this.handleSortColumn}
                                                        >
                                                            <Column width={50} align="center">
                                                                <HeaderCell>ลำดับ</HeaderCell>
                                                                <Cell dataKey="index" />
                                                            </Column>

                                                            <Column width={75} resizable>
                                                                <HeaderCell>คำนำหน้า</HeaderCell>
                                                                <Cell dataKey="prefix" />
                                                            </Column>

                                                            <Column width={185} resizable>
                                                                <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
                                                                <Cell>
                                                                    {rowData => (
                                                                        <span dangerouslySetInnerHTML={{ __html: rowData.name }} />
                                                                    )}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={80}>
                                                                <HeaderCell>ชื่อเล่น</HeaderCell>
                                                                <Cell dataKey="nickname" />
                                                            </Column>

                                                            <Column width={70} resizable>
                                                                <HeaderCell>อายุ</HeaderCell>
                                                                <Cell dataKey="age" />
                                                            </Column>

                                                            <Column width={135} resizable>
                                                                <HeaderCell>หมู่บ้าน</HeaderCell>
                                                                <Cell dataKey="village" />
                                                            </Column>

                                                            <Column width={210} resizable>
                                                                <HeaderCell>สถานศึกษาเรียนต่อ</HeaderCell>
                                                                <Cell dataKey="school" />
                                                            </Column>

                                                            <Column width={160} resizable>
                                                                <HeaderCell align='center'>
                                                                    คณะกรรมการลงคะแนน
                                                                </HeaderCell>
                                                                <Cell
                                                                    align="center"
                                                                    style={{ backgroundColor: '#fcf9f5ff' }}
                                                                >
                                                                    {rowData => {
                                                                        const group = rowData.voting.group1;
                                                                        return group.isComplete ? (
                                                                            <span style={{ color: '#4CAF50' }}>
                                                                                ✔ ครบ ({group.votedCount}/{group.total})
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ color: '#FF8A80' }}>
                                                                                ✖ ไม่ครบ ({group.votedCount}/{group.total})
                                                                            </span>
                                                                        );
                                                                    }}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={125} resizable sortable>
                                                                <HeaderCell align='center'>
                                                                    คะแนนเฉลี่ย
                                                                </HeaderCell>
                                                                <Cell
                                                                    dataKey="averageScoreGroup1"
                                                                    align="center"
                                                                    style={{ backgroundColor: '#fcf9f5ff' }}
                                                                >
                                                                    {rowData => rowData.voting.group1.averageScore ?? '-'}
                                                                </Cell>
                                                            </Column>

                                                            {/* คอลัมน์ปุ่มจัดการ */}
                                                            <Column width={185} fixed="right" align="center">
                                                                <HeaderCell>...</HeaderCell>
                                                                <Cell style={{ padding: '4px' }}>
                                                                    {rowData => (
                                                                        <ButtonToolbar>
                                                                            <Whisper followCursor speaker={<Tooltip>ดูรายละเอียด</Tooltip>}>
                                                                                <a
                                                                                    href={`/admin/applicant/detail/${rowData.id}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <IconButton
                                                                                        size="xs"
                                                                                        color="blue"
                                                                                        appearance="primary"
                                                                                        icon={<i className="bi bi-file-earmark-text"></i>}
                                                                                    />
                                                                                </a>
                                                                            </Whisper>

                                                                            <Whisper followCursor speaker={<Tooltip>คัดเลือก</Tooltip>}>
                                                                                <IconButton
                                                                                    size="xs"
                                                                                    color="green"
                                                                                    appearance="primary"
                                                                                    icon={<i className="bi bi-person-check"></i>}
                                                                                    onClick={() =>
                                                                                        this.onModalEdit({ mode: 'consider', id: rowData.id })
                                                                                    }
                                                                                />
                                                                            </Whisper>

                                                                            <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                                <a
                                                                                    href={`/admin/applicant/edit/${rowData.id}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <IconButton
                                                                                        size="xs"
                                                                                        color="yellow"
                                                                                        appearance="primary"
                                                                                        icon={<i className="bi bi-pencil-square"></i>}
                                                                                    />
                                                                                </a>
                                                                            </Whisper>

                                                                            <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                                <IconButton
                                                                                    size="xs"
                                                                                    color="red"
                                                                                    appearance="primary"
                                                                                    icon={<i className="bi bi-trash-fill"></i>}
                                                                                    onClick={() =>
                                                                                        this.onConfirm({ mode: 'delete', id: rowData.id })
                                                                                    }
                                                                                />
                                                                            </Whisper>
                                                                        </ButtonToolbar>
                                                                    )}
                                                                </Cell>
                                                            </Column>
                                                        </Table>

                                                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '12px' }}>
                                                            <Whisper placement="top" speaker={<Tooltip>ดาวน์โหลด Excel คณะกรรมการชุดที่ 1</Tooltip>}>
                                                                <Button
                                                                    appearance="subtle"
                                                                    startIcon={<i className="bi bi-file-earmark-excel-fill" style={{ color: '#1a7a47' }}></i>}
                                                                    onClick={() => this.downloadScoreExcel({ group: 1 })}
                                                                >
                                                                    ดาวน์โหลด Excel
                                                                </Button>
                                                            </Whisper>
                                                        </div>

                                                    </Tabs.Tab>
                                                    <Tabs.Tab eventKey="2" title={<><i className="bi bi-person-check-fill" style={{ marginRight: '6px' }}></i>คณะกรรมการชุดที่ 2</>}>

                                                        <Table
                                                            autoHeight
                                                            data={this.state.data.filter(item => item.committee1_result === true)}
                                                            bordered
                                                            cellBordered
                                                            sortColumn={this.state.sortColumn}
                                                            sortType={this.state.sortType}
                                                            onSortColumn={this.handleSortColumn}
                                                        >
                                                            <Column width={50} align="center">
                                                                <HeaderCell>ลำดับ</HeaderCell>
                                                                <Cell dataKey="index" />
                                                            </Column>

                                                            <Column width={80} resizable>
                                                                <HeaderCell>คำนำหน้า</HeaderCell>
                                                                <Cell dataKey="prefix" />
                                                            </Column>

                                                            <Column width={190} resizable>
                                                                <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
                                                                <Cell>
                                                                    {rowData => (
                                                                        <span dangerouslySetInnerHTML={{ __html: rowData.name }} />
                                                                    )}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={90}>
                                                                <HeaderCell>ชื่อเล่น</HeaderCell>
                                                                <Cell dataKey="nickname" />
                                                            </Column>

                                                            <Column width={70} resizable>
                                                                <HeaderCell>อายุ</HeaderCell>
                                                                <Cell dataKey="age" />
                                                            </Column>

                                                            <Column width={165} resizable>
                                                                <HeaderCell align='center'>คณะกรรมการชุดที่ 1</HeaderCell>
                                                                <Cell align="center">
                                                                    {rowData => {
                                                                        const group = rowData.voting.group1;
                                                                        return group.isComplete ? (
                                                                            <span style={{ color: '#4CAF50' }}>
                                                                                ✔ ครบ ({group.votedCount}/{group.total})
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ color: '#FF8A80' }}>
                                                                                ✖ ไม่ครบ ({group.votedCount}/{group.total})
                                                                            </span>
                                                                        );
                                                                    }}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={140} resizable sortable>
                                                                <HeaderCell align='center'>คะแนนชุดที่ 1</HeaderCell>
                                                                <Cell align="center" dataKey="averageScoreGroup1">{rowData => rowData.voting.group1.averageScore}</Cell>
                                                            </Column>

                                                            <Column width={165} resizable>
                                                                <HeaderCell align='center'>
                                                                    คณะกรรมการชุดที่ 2
                                                                </HeaderCell>
                                                                <Cell
                                                                    align="center"
                                                                    style={{ backgroundColor: '#fcf9f5ff' }}
                                                                >
                                                                    {rowData => {
                                                                        const group = rowData.voting.group2;
                                                                        return group.isComplete ? (
                                                                            <span style={{ color: '#4CAF50' }}>
                                                                                ✔ ครบ ({group.votedCount}/{group.total})
                                                                            </span>
                                                                        ) : (
                                                                            <span style={{ color: '#FF8A80' }}>
                                                                                ✖ ไม่ครบ ({group.votedCount}/{group.total})
                                                                            </span>
                                                                        );
                                                                    }}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={140} resizable sortable>
                                                                <HeaderCell align='center'>
                                                                    คะแนนชุดที่ 2
                                                                </HeaderCell>
                                                                <Cell
                                                                    dataKey="averageScoreGroup2"
                                                                    align="center"
                                                                    style={{ backgroundColor: '#fcf9f5ff' }}
                                                                >
                                                                    {rowData => rowData.voting.group2.averageScore ?? '-'}
                                                                </Cell>
                                                            </Column>

                                                            {/* คอลัมน์ปุ่มจัดการ */}
                                                            <Column width={185} fixed="right" align="center">
                                                                <HeaderCell>...</HeaderCell>
                                                                <Cell style={{ padding: '4px' }}>
                                                                    {rowData => (
                                                                        <ButtonToolbar>
                                                                            <Whisper followCursor speaker={<Tooltip>ดูรายละเอียด</Tooltip>}>
                                                                                <a
                                                                                    href={`/admin/applicant/detail/${rowData.id}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <IconButton
                                                                                        size="xs"
                                                                                        color="blue"
                                                                                        appearance="primary"
                                                                                        icon={<i className="bi bi-file-earmark-text"></i>}
                                                                                    />
                                                                                </a>
                                                                            </Whisper>

                                                                            <Whisper followCursor speaker={<Tooltip>คัดเลือก</Tooltip>}>
                                                                                <IconButton
                                                                                    size="xs"
                                                                                    color="green"
                                                                                    appearance="primary"
                                                                                    icon={<i className="bi bi-person-check"></i>}
                                                                                    onClick={() =>
                                                                                        this.onModalEdit({ mode: 'consider', id: rowData.id })
                                                                                    }
                                                                                />
                                                                            </Whisper>

                                                                            <Whisper followCursor speaker={<Tooltip>แก้ไข</Tooltip>}>
                                                                                <a
                                                                                    href={`/admin/applicant/edit/${rowData.id}`}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                >
                                                                                    <IconButton
                                                                                        size="xs"
                                                                                        color="yellow"
                                                                                        appearance="primary"
                                                                                        icon={<i className="bi bi-pencil-square"></i>}
                                                                                    />
                                                                                </a>
                                                                            </Whisper>

                                                                            <Whisper followCursor speaker={<Tooltip>ลบ</Tooltip>}>
                                                                                <IconButton
                                                                                    size="xs"
                                                                                    color="red"
                                                                                    appearance="primary"
                                                                                    icon={<i className="bi bi-trash-fill"></i>}
                                                                                    onClick={() =>
                                                                                        this.onConfirm({ mode: 'delete', id: rowData.id })
                                                                                    }
                                                                                />
                                                                            </Whisper>
                                                                        </ButtonToolbar>
                                                                    )}
                                                                </Cell>
                                                            </Column>
                                                        </Table>

                                                        <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '12px' }}>
                                                            <Whisper placement="top" speaker={<Tooltip>ดาวน์โหลด Excel คณะกรรมการชุดที่ 1</Tooltip>}>
                                                                <Button
                                                                    appearance="subtle"
                                                                    startIcon={<i className="bi bi-file-earmark-excel-fill" style={{ color: '#1a7a47' }}></i>}
                                                                    onClick={() => this.downloadScoreExcel({ group: 2 })}
                                                                >
                                                                    ดาวน์โหลด Excel
                                                                </Button>
                                                            </Whisper>
                                                        </div>

                                                    </Tabs.Tab>
                                                </Tabs>
                                            </Tabs.Tab>
                                            <Tabs.Tab eventKey="3" title={
                                                <><i className="bi bi-sort-down me-2" style={{ color: '#8b5cf6' }}></i>เรียงลำดับผู้สมัคร</>
                                            } >
                                                <Tabs
                                                    defaultActiveKey="1"
                                                    style={{
                                                        backgroundColor: '#f9f9f9',
                                                        borderRadius: '10px',
                                                        padding: '10px',
                                                        boxShadow: '0 4px 10px rgba(0,0,0,0.05)',
                                                    }}>
                                                    <Tabs.Tab eventKey="1" title={<><i className="bi bi-person-lines-fill" style={{ marginRight: '6px' }}></i>คณะกรรมการชุดที่ 1</>}>
                                                        <Table
                                                            autoHeight
                                                            data={this.state.data}
                                                            bordered
                                                            cellBordered
                                                            className="shadow-sm"
                                                        >
                                                            <Column width={50} align="center">
                                                                <HeaderCell>ลำดับ</HeaderCell>
                                                                <Cell dataKey="index" />
                                                            </Column>

                                                            <Column width={80} resizable>
                                                                <HeaderCell>คำนำหน้า</HeaderCell>
                                                                <Cell dataKey="prefix" />
                                                            </Column>

                                                            <Column width={190} resizable>
                                                                <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
                                                                <Cell>
                                                                    {rowData => (
                                                                        <span dangerouslySetInnerHTML={{ __html: rowData.name }} />
                                                                    )}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={80}>
                                                                <HeaderCell>ชื่อเล่น</HeaderCell>
                                                                <Cell dataKey="nickname" />
                                                            </Column>

                                                            <Column width={55} resizable>
                                                                <HeaderCell>อายุ</HeaderCell>
                                                                <Cell dataKey="age" />
                                                            </Column>

                                                            <Column width={120} resizable>
                                                                <HeaderCell>เบอร์โทรศัพท์</HeaderCell>
                                                                <Cell dataKey="tel" />
                                                            </Column>

                                                            <Column width={135} resizable>
                                                                <HeaderCell>หมู่บ้าน</HeaderCell>
                                                                <Cell dataKey="village" />
                                                            </Column>

                                                            <Column width={185} resizable>
                                                                <HeaderCell>สถานศึกษาเรียนต่อ</HeaderCell>
                                                                <Cell dataKey="school" />
                                                            </Column>

                                                            <Column width={280} resizable>
                                                                <HeaderCell>สถานะการสมัครเรียน</HeaderCell>
                                                                <Cell dataKey="status" />
                                                            </Column>

                                                            <Column width={100} resizable>
                                                                <HeaderCell align='center'>กำหนดลำดับ</HeaderCell>
                                                                <Cell style={{ padding: '4px' }}>
                                                                    {rowData => {
                                                                        // หาค่า sort ของแถวปัจจุบันจาก orderDataGroup1
                                                                        const currentSortObj = this.state.orderDataGroup1.find(
                                                                            item => item.id === rowData.id
                                                                        );
                                                                        const currentSort = currentSortObj ? currentSortObj.sort : 0; // ถ้าไม่มี ให้เป็น 0

                                                                        return (
                                                                            <InputNumber
                                                                                size='md'
                                                                                defaultValue={currentSort} // หรือใช้ value={currentSort} ถ้าต้องการควบคุม
                                                                                min={0}
                                                                                max={this.state.data.length}
                                                                                step={1}
                                                                                onChange={e => this.orderCandidates({ groups: 1, id: rowData.id, sort: e })}
                                                                            />
                                                                        );
                                                                    }}
                                                                </Cell>
                                                            </Column>
                                                        </Table>

                                                        <Button
                                                            className='mt-3'
                                                            color='orange'
                                                            appearance="primary"
                                                            startIcon={<i className="bi bi-floppy-fill"></i>}
                                                            onClick={() => this.submitOrderGroup(1)}
                                                        >
                                                            บันทึกการจัดลำดับ
                                                        </Button>

                                                    </Tabs.Tab>
                                                    <Tabs.Tab eventKey="2" title={<><i className="bi bi-person-check-fill" style={{ marginRight: '6px' }}></i>คณะกรรมการชุดที่ 2</>}>
                                                        <Table
                                                            autoHeight
                                                            data={this.state.data.filter(item => item.committee1_result === true)}
                                                            bordered
                                                            cellBordered
                                                            className="shadow-sm"
                                                        >
                                                            <Column width={50} align="center">
                                                                <HeaderCell>ลำดับ</HeaderCell>
                                                                <Cell dataKey="index" />
                                                            </Column>

                                                            <Column width={80} resizable>
                                                                <HeaderCell>คำนำหน้า</HeaderCell>
                                                                <Cell dataKey="prefix" />
                                                            </Column>

                                                            <Column width={190} resizable>
                                                                <HeaderCell>ชื่อ-นามสกุล</HeaderCell>
                                                                <Cell>
                                                                    {rowData => (
                                                                        <span dangerouslySetInnerHTML={{ __html: rowData.name }} />
                                                                    )}
                                                                </Cell>
                                                            </Column>

                                                            <Column width={80}>
                                                                <HeaderCell>ชื่อเล่น</HeaderCell>
                                                                <Cell dataKey="nickname" />
                                                            </Column>

                                                            <Column width={55} resizable>
                                                                <HeaderCell>อายุ</HeaderCell>
                                                                <Cell dataKey="age" />
                                                            </Column>

                                                            <Column width={120} resizable>
                                                                <HeaderCell>เบอร์โทรศัพท์</HeaderCell>
                                                                <Cell dataKey="tel" />
                                                            </Column>

                                                            <Column width={135} resizable>
                                                                <HeaderCell>หมู่บ้าน</HeaderCell>
                                                                <Cell dataKey="village" />
                                                            </Column>

                                                            <Column width={185} resizable>
                                                                <HeaderCell>สถานศึกษาเรียนต่อ</HeaderCell>
                                                                <Cell dataKey="school" />
                                                            </Column>

                                                            <Column width={280} resizable>
                                                                <HeaderCell>สถานะการสมัครเรียน</HeaderCell>
                                                                <Cell dataKey="status" />
                                                            </Column>

                                                            <Column width={100} resizable>
                                                                <HeaderCell align='center'>กำหนดลำดับ</HeaderCell>
                                                                <Cell style={{ padding: '4px' }}>
                                                                    {rowData => {
                                                                        // ดึงค่า sort ของแถวปัจจุบันจาก orderDataGroup2
                                                                        const currentSortObj = this.state.orderDataGroup2.find(
                                                                            item => item.id === rowData.id
                                                                        );
                                                                        const currentSort = currentSortObj ? currentSortObj.sort : 0; // ถ้าไม่มี ให้เป็น 0

                                                                        return (
                                                                            <InputNumber
                                                                                size='md'
                                                                                defaultValue={currentSort} // หรือ value={currentSort} สำหรับ controlled component
                                                                                min={0}
                                                                                max={this.state.data.filter(item => item.committee1_result === true).length}
                                                                                step={1}
                                                                                onChange={e => this.orderCandidates({ groups: 2, id: rowData.id, sort: e })}
                                                                            />
                                                                        );
                                                                    }}
                                                                </Cell>
                                                            </Column>
                                                        </Table>

                                                        <Button
                                                            className='mt-3'
                                                            color='orange'
                                                            appearance="primary"
                                                            startIcon={<i className="bi bi-floppy-fill"></i>}
                                                            onClick={() => this.submitOrderGroup(2)}
                                                        >
                                                            บันทึกการจัดลำดับ
                                                        </Button>
                                                    </Tabs.Tab>
                                                </Tabs>
                                            </Tabs.Tab>
                                        </Tabs>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <br />
                    </>
                })

                await this.promisedSetState({ loading: false })
            } catch {
                // Redirect to Log In
                window.location.href = '/admin/login';
            }
        }
    }

    downloadScoreExcel = async ({ group }) => {
        try {
            await this.promisedSetState({ loading: true });

            const ExcelJS = (await import('exceljs')).default;
            const saveAs = (blob, fileName) => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                a.click();
                URL.revokeObjectURL(url);
            };

            const committeeRes = await axios.get(
                `${process.env.REACT_APP_API}/committee/year/${this.state.defaultYear}/${group}`,
                this.state.authHeader
            );
            const committees = committeeRes.data || [];

            const applicants = group === 1
                ? this.state.data
                : this.state.data.filter(item => item.committee1_result === true);

            const groupKey = group === 1 ? 'group1' : 'group2';
            const orderData = group === 1
                ? this.state.orderDataGroup1
                : this.state.orderDataGroup2;

            // เรียงคะแนนเพื่อกำหนดอันดับ
            const sorted = [...applicants].sort((a, b) => {
                const scoreA = a.voting[groupKey].averageScore ?? -1;
                const scoreB = b.voting[groupKey].averageScore ?? -1;
                return scoreB - scoreA;
            });

            const rankMap = {};
            sorted.forEach((applicant, idx) => {
                rankMap[applicant.id] = idx + 1;
            });

            // เรียงตาม orderData
            const sortedApplicants = [...applicants].sort((a, b) => {
                const orderA = orderData.find(o => o.id === a.id)?.sort ?? 9999;
                const orderB = orderData.find(o => o.id === b.id)?.sort ?? 9999;
                return orderA - orderB;
            });

            // ดึงคะแนนรายกรรมการ
            const rowsData = await Promise.all(sortedApplicants.map(async (applicant) => {
                const scoreRes = await axios.get(
                    `${process.env.REACT_APP_API}/application/scores/${this.state.defaultYear}/${applicant.id}/${group}`,
                    this.state.authHeader
                );

                const scores = scoreRes.data || [];
                const orderObj = orderData.find(o => o.id === applicant.id);
                const orderNo = orderObj?.sort || '-';
                const voting = applicant.voting[groupKey];

                // ⭐ ดึงรูปภาพ
                let imageBase64 = null;
                let imageExtension = 'jpeg';
                try {
                    const imgUrl = `${process.env.REACT_APP_UPLOAD}/${applicant.data.path}`;
                    const imgRes = await axios.get(imgUrl, { responseType: 'arraybuffer' });
                    const base64 = btoa(
                        new Uint8Array(imgRes.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                    );
                    imageBase64 = base64;
                    const ext = applicant.data.path?.split('.').pop()?.toLowerCase();
                    imageExtension = ['png', 'jpeg', 'jpg', 'gif'].includes(ext)
                        ? (ext === 'jpg' ? 'jpeg' : ext)
                        : 'jpeg';
                } catch {
                    imageBase64 = null;
                }

                const scoreMap = {};
                committees.forEach(c => {
                    const found = scores.find(s => s.committee_id === c.id);
                    scoreMap[c.name] = found?.score ?? '-';
                });

                return {
                    orderNo: orderNo !== 0 ? orderNo : '-',
                    imageBase64,
                    imageExtension,
                    name: `${applicant.prefix}${applicant.data.first_name} ${applicant.data.last_name}`,
                    nickname: applicant.nickname,
                    field: applicant.data?.next_field || '-',
                    school: applicant.school || '-',
                    scoreMap,
                    averageScore: voting.averageScore ?? '-',
                    rank: voting.averageScore != null ? rankMap[applicant.id] : '-',
                };
            }));

            // ⭐ สร้าง workbook ด้วย ExcelJS
            const wb = new ExcelJS.Workbook();
            const ws = wb.addWorksheet(`ชุดที่${group}`);

            const fixedHeaders = ['ลำดับ', 'รูปภาพ', 'รายชื่อ', 'ชื่อเล่น', 'สาขาการเรียน', 'มหาวิทยาลัย'];
            const committeeNames = committees.map(c => c.name);
            const tailHeaders = ['คะแนนเฉลี่ย', 'อันดับที่ได้'];
            const allHeaders = [...fixedHeaders, ...committeeNames, ...tailHeaders];

            // ⭐ Row 1 header
            const row1Values = [
                ...fixedHeaders,
                'คณะกรรมการ',
                ...committeeNames.slice(1).map(() => ''),
                ...tailHeaders
            ];

            // ⭐ Row 2 header (ชื่อกรรมการ)
            const row2Values = [
                ...fixedHeaders.map(() => ''),
                ...committeeNames,
                ...tailHeaders.map(() => '')
            ];

            const headerRow1 = ws.addRow(row1Values);
            const headerRow2 = ws.addRow(row2Values);

            // style header
            [headerRow1, headerRow2].forEach(row => {
                row.eachCell(cell => {
                    cell.font = { bold: true, size: 11 };
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD6EAF8' } };
                    cell.border = {
                        top: { style: 'thin' }, bottom: { style: 'thin' },
                        left: { style: 'thin' }, right: { style: 'thin' }
                    };
                });
            });

            // ⭐ Merge header
            const imgCol = 2; // คอลัมน์รูปภาพ
            // merge fixedHeaders แนวตั้ง
            fixedHeaders.forEach((_, i) => {
                ws.mergeCells(1, i + 1, 2, i + 1);
            });
            // merge "คณะกรรมการ" แนวนอน
            const mergeStart = fixedHeaders.length + 1;
            const mergeEnd = fixedHeaders.length + committeeNames.length;
            if (committeeNames.length > 1) {
                ws.mergeCells(1, mergeStart, 1, mergeEnd);
            }
            // merge tailHeaders แนวตั้ง
            tailHeaders.forEach((_, i) => {
                const col = fixedHeaders.length + committeeNames.length + i + 1;
                ws.mergeCells(1, col, 2, col);
            });

            // ⭐ ความกว้างคอลัมน์
            ws.getColumn(1).width = 8;   // ลำดับ
            ws.getColumn(2).width = 14;  // รูปภาพ
            ws.getColumn(3).width = 25;  // รายชื่อ
            ws.getColumn(4).width = 12;  // ชื่อเล่น
            ws.getColumn(5).width = 20;  // สาขา
            ws.getColumn(6).width = 25;  // มหาวิทยาลัย
            committeeNames.forEach((_, i) => {
                ws.getColumn(7 + i).width = 16;
            });
            ws.getColumn(7 + committeeNames.length).width = 14;     // คะแนนเฉลี่ย
            ws.getColumn(7 + committeeNames.length + 1).width = 12; // อันดับ

            // ⭐ เพิ่มข้อมูลแต่ละแถว
            const imageRowHeight = 80;

            for (let i = 0; i < rowsData.length; i++) {
                const d = rowsData[i];
                const excelRowIndex = i + 3; // เริ่ม row 3

                const rowValues = [
                    d.orderNo, '', d.name, d.nickname, d.field, d.school,
                    ...committeeNames.map(name => d.scoreMap[name] ?? '-'),
                    d.averageScore, d.rank
                ];

                const dataRow = ws.addRow(rowValues);
                dataRow.height = imageRowHeight;

                dataRow.eachCell((cell, colNum) => {
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    cell.border = {
                        top: { style: 'thin' }, bottom: { style: 'thin' },
                        left: { style: 'thin' }, right: { style: 'thin' }
                    };
                });

                // ⭐ ใส่รูปภาพ
                if (d.imageBase64) {
                    const imageId = wb.addImage({
                        base64: d.imageBase64,
                        extension: d.imageExtension,
                    });

                    ws.addImage(imageId, {
                        tl: { col: 1, row: excelRowIndex - 1 },  // col 1 = คอลัมน์ B (รูปภาพ)
                        ext: { width: 70, height: 95 },
                        editAs: 'oneCell'
                    });
                }
            }

            // ⭐ Export
            const buffer = await wb.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const randomStr = Math.random().toString(36).substring(2, 7).toUpperCase();
            saveAs(blob, `คะแนนชุดที่${group}_${this.state.defaultYear}_${randomStr}.xlsx`);

        } catch (err) {
            console.error('Download Excel error:', err);
            alert(`เกิดข้อผิดพลาด: ${err.message}`);
        } finally {
            await this.promisedSetState({ loading: false }); // ⭐ หยุด loading ไม่ว่าจะสำเร็จหรือ error
        }
    };

    // ฟังก์ชันจัดการ order
    orderCandidates = async ({ groups, id, sort }) => {
        if (sort < 1) return; // ป้องกัน sort <= 0 ถ้าต้องการ

        if (groups === 1) {
            this.setState(prevState => {
                const orderDataGroup1 = [...prevState.orderDataGroup1];

                // ตรวจสอบว่ามี sort ซ้ำกับแถวอื่น
                const duplicateSort = orderDataGroup1.some(
                    item => item.sort === sort && item.id !== id
                );

                if (duplicateSort) {
                    Swal.fire({
                        title: "ลำดับที่เลือกถูกใช้งานแล้ว",
                        icon: "error",
                        timer: 1500,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                    return null; // ไม่อัปเดต state
                }

                const index = orderDataGroup1.findIndex(item => item.id === id);

                if (index !== -1) {
                    orderDataGroup1[index].sort = sort;
                } else {
                    orderDataGroup1.push({ groups, id, sort });
                }

                console.log("Current JSON Group 1:", orderDataGroup1);
                return { orderDataGroup1 };
            });
        } else if (groups === 2) {
            this.setState(prevState => {
                const orderDataGroup2 = [...prevState.orderDataGroup2];

                // ตรวจสอบ sort ซ้ำ
                const duplicateSort = orderDataGroup2.some(
                    item => item.sort === sort && item.id !== id
                );

                if (duplicateSort) {
                    Swal.fire({
                        title: "ลำดับที่เลือกถูกใช้งานแล้ว",
                        icon: "error",
                        timer: 1500,
                        timerProgressBar: true,
                        confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                    });
                    return null;
                }

                const index = orderDataGroup2.findIndex(item => item.id === id);

                if (index !== -1) {
                    orderDataGroup2[index].sort = sort;
                } else {
                    orderDataGroup2.push({ groups, id, sort });
                }

                console.log("Current JSON Group 2:", orderDataGroup2);
                return { orderDataGroup2 };
            });
        }
    };

    submitOrderGroup = async (group) => {
        const { orderDataGroup1, orderDataGroup2, defaultYear } = this.state;

        const selectedGroupData = group === 1 ? orderDataGroup1 : orderDataGroup2;

        if (selectedGroupData.length === 0) {
            Swal.fire({
                title: "กรุณาจัดลำดับก่อนบันทึก",
                icon: "warning",
                timer: 1500
            });
            return;
        }

        try {
            await axios.post(
                `${process.env.REACT_APP_API}/committee-order`,
                {
                    year: defaultYear,
                    groups: group,
                    order: selectedGroupData,
                    user: this.state.createdBy || "system"
                },
                this.state.authHeader
            );

            Swal.fire({
                title: `บันทึกข้อมูลคณะกรรมการกลุ่ม ${group} สำเร็จ`,
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
            }).then(async () => {
                if (group === 1) {
                    await this.promisedSetState({ orderDataGroup1: [] });
                } else {
                    await this.promisedSetState({ orderDataGroup2: [] });
                }

                await this.onRenderContent({ mode: 'read' });
            });

        } catch (error) {
            console.error("Error saving committee order:", error);
            Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: error.message || "ไม่สามารถบันทึกข้อมูลได้",
                icon: "error",
                timer: 2000
            });
        }
    };

    onModalEdit = async ({ mode, id }) => {
        if (mode === 'consider') {
            this.promisedSetState({ loading: true }); // 👉 เริ่มโหลด

            const { Column, HeaderCell, Cell } = Table;

            try {
                // 👉 โหลดข้อมูลผู้สมัคร
                const response = await axios.get(
                    `${process.env.REACT_APP_API}/application/${id}`,
                    this.state.authHeader
                );
                const data = response.data[0];

                // 📌 ฟังก์ชันโหลดคณะกรรมการ + คะแนนโหวต + คำนวณคะแนนเฉลี่ย
                const loadCommitteeWithScore = async (group) => {
                    // โหลดคณะกรรมการตามชุด
                    const res = await axios.get(
                        `${process.env.REACT_APP_API}/committee/year/${this.state.defaultYear}/${group}`,
                        this.state.authHeader
                    );
                    const committee = res.data || [];

                    // โหลดคะแนนโหวต
                    const voteData = await Promise.all(
                        committee.map(async (item, i) => {
                            try {
                                const votingRes = await axios.get(
                                    `${process.env.REACT_APP_API}/voting/by-keys/${this.state.defaultYear}/${item.id}/${id}`,
                                    this.state.authHeader
                                );

                                const voting = votingRes.data;

                                return {
                                    id: i + 1,
                                    name: item.name,
                                    comment: voting?.comment ?? '',
                                    vote: !!voting, // true = โหวตแล้ว
                                    score: voting?.total ?? 0
                                };
                            } catch {
                                return {
                                    id: i + 1,
                                    name: item.name,
                                    comment: '',
                                    vote: false,
                                    score: 0
                                };
                            }
                        })
                    );

                    // คำนวณคะแนนเฉลี่ยเฉพาะคนที่ vote = true
                    const votedOnly = voteData.filter(r => r.vote);
                    const avg =
                        votedOnly.length > 0
                            ? (votedOnly.reduce((sum, r) => sum + Number(r.score || 0), 0) / votedOnly.length).toFixed(2)
                            : "0.00";

                    // เพิ่มแถวคะแนนเฉลี่ย
                    return [
                        ...voteData,
                        { isTotalRow: true, id: null, name: "คะแนนเฉลี่ย", vote: null, score: avg }
                    ];
                };

                // 📌 โหลดทั้ง 2 ชุดแบบสั้น
                const dataWithAverage_1 = await loadCommitteeWithScore(1);
                const dataWithAverage_2 = await loadCommitteeWithScore(2);

                // 👉 เซ็ตข้อมูลที่ใช้ใน Modal
                await this.promisedSetState({
                    committee1_result: data.committee1_result,
                    committee1_comment: data.committee1_comment,
                    committee2_result: data.committee2_result,
                    decision_result: data.decision_result,
                    cost_of_living: data.cost_of_living,
                    tuition_fee: data.tuition_fee,
                    dormitory: data.dormitory,
                    registration: data.registration,
                    loading: false // ✅ หยุดโหลด
                });

                // 👉 แสดง Modal
                this.setState({
                    modal: (
                        <Modal backdrop="static" size="lg" keyboard={false} open onClose={() => this.setState({ modal: null })}>
                            <Modal.Header>
                                <Modal.Title>การคัดเลือกรับทุนการศึกษา</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Container>
                                    <Text
                                        weight="bold"
                                        style={{
                                            backgroundColor: "rgb(138, 10, 10)",
                                            color: "white",
                                            padding: "8px 12px",
                                            borderRadius: "4px",
                                            display: "inline-block"
                                        }}
                                    >
                                        ข้อมูลส่วนตัวผู้สมัคร
                                    </Text>

                                    <Panel
                                        bordered
                                        style={{ padding: '12px' }}
                                    >

                                        {/* ข้อมูลผู้สมัคร */}
                                        <HStack><label>ชื่อ-นามสกุล: </label><Text>{`${data.first_name} ${data.last_name}`}</Text></HStack>
                                        <HStack><label>ชื่อเล่น: </label><Text>{data.nickname}</Text></HStack>
                                        <HStack><label>ที่อยู่: </label><Text>
                                            {data.reg_province_id === 1
                                                ? `${data.reg_house_number} หมู่ ${data.reg_village_no} หมู่บ้าน${data.reg_village === 'other' ? data.reg_village_name : data.reg_village} ${data.reg_tambon} ${data.reg_amphur} ${data.reg_province}`
                                                : `${data.reg_house_number} หมู่ ${data.reg_village_no} หมู่บ้าน${data.reg_village === 'other' ? data.reg_village_name : data.reg_village} ต.${data.reg_tambon} อ.${data.reg_amphur} จ.${data.reg_province}`
                                            }
                                        </Text></HStack>
                                        <HStack><label>สถานศึกษาที่จะเรียนต่อ: </label><Text>{data.next_institution}</Text></HStack>
                                    </Panel>

                                    <Text
                                        className='mt-3'
                                        weight="bold"
                                        style={{
                                            backgroundColor: "rgb(138, 10, 10)",
                                            color: "white",
                                            padding: "8px 12px",
                                            borderRadius: "4px",
                                            display: "inline-block"
                                        }}
                                    >
                                        ผลการคัดเลือกจากคณะกรรมการ
                                    </Text>

                                    <Panel

                                        bordered
                                        style={{ padding: '12px' }}
                                    >
                                        {/* Toggle สถานะการคัดเลือก */}
                                        <HStack
                                            className="mb-3 p-3"
                                            style={{
                                                backgroundColor: '#f0f0f0',   // เทาอ่อน
                                                borderRadius: '8px',
                                                border: '1px solid #b0b0b0',  // เทาเข้มแบบ soft
                                                padding: '8px'
                                            }}
                                            spacing={4}
                                            align="center"
                                        >
                                            <label
                                                style={{
                                                    fontWeight: 'bold',
                                                    color: '#4a4a4a'   // เทาเข้ม เพื่อให้อ่านง่าย
                                                }}
                                            >
                                                สถานะการคัดเลือก :
                                            </label>

                                            <Toggle
                                                checkedChildren="ผ่าน"
                                                unCheckedChildren="ไม่ผ่าน"
                                                defaultChecked={this.state.decision_result}
                                                onChange={e => this.setState({ decision_result: e })}
                                            />
                                        </HStack>

                                        {/* ตารางคะแนนจากคณะกรรมการชุดที่ 1 */}
                                        <Panel
                                            header={
                                                <>
                                                    <Text className='mb-2'>สรุปผลจากคณะกรรมการชุดที่ 1 :{' '}<Toggle
                                                        checkedChildren="ผ่าน"
                                                        unCheckedChildren="ไม่ผ่าน"
                                                        defaultChecked={this.state.committee1_result}
                                                        onChange={e => this.setState({ committee1_result: e })}
                                                        style={{ fontWeight: 'normal' }}
                                                    /></Text>
                                                </>
                                            }
                                            bordered
                                            style={{ padding: '8px' }}
                                        >

                                            <table
                                                style={{
                                                    width: "100%",
                                                    borderCollapse: "collapse",
                                                    marginBottom: "16px"
                                                }}
                                            >
                                                <thead>
                                                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                                                        <th
                                                            style={{
                                                                width: "50px",
                                                                border: "1px solid #ccc",
                                                                padding: "8px",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            ลำดับ
                                                        </th>
                                                        <th
                                                            style={{
                                                                width: "500px",
                                                                border: "1px solid #ccc",
                                                                padding: "8px",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            รายชื่อคณะกรรมการ
                                                        </th>
                                                        <th
                                                            style={{
                                                                width: "155px",
                                                                border: "1px solid #ccc",
                                                                padding: "8px",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            ลงคะแนน
                                                        </th>
                                                        <th
                                                            style={{
                                                                width: "180px",
                                                                border: "1px solid #ccc",
                                                                padding: "8px",
                                                                fontWeight: "bold",
                                                                textAlign: "center",
                                                                verticalAlign: "top"
                                                            }}
                                                        >
                                                            คะแนน
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {dataWithAverage_1.map((row, index) => (
                                                        <tr key={index}>
                                                            <td
                                                                style={{
                                                                    width: "50px",
                                                                    border: "1px solid #ccc",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                    verticalAlign: "top"
                                                                }}
                                                            >
                                                                {row.id}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    width: "500px",
                                                                    border: "1px solid #ccc",
                                                                    padding: "8px",
                                                                    verticalAlign: "top"
                                                                }}
                                                            >
                                                                {row.name}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    width: "155px",
                                                                    border: "1px solid #ccc",
                                                                    padding: "8px",
                                                                    textAlign: "center",
                                                                    verticalAlign: "top"
                                                                }}
                                                            >
                                                                {row.isTotalRow ? (
                                                                    <strong>{row.vote}</strong>
                                                                ) : row.vote ? (
                                                                    <span style={{ color: "green" }}>
                                                                        <i className="bi bi-check-lg"></i>
                                                                    </span>
                                                                ) : (
                                                                    <span>&nbsp;</span>
                                                                )}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    width: "180px",
                                                                    border: "1px solid #ccc",
                                                                    padding: "8px",
                                                                    textAlign: "right",
                                                                    verticalAlign: "top"
                                                                }}
                                                            >
                                                                {row.isTotalRow ? <strong>{row.score}</strong> : row.score}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            <Row className='mt-3'>
                                                <Col>
                                                    <Text weight="bold" className="mb-2">ข้อสังเกต/ข้อคิดเห็นอื่นๆ </Text>
                                                    <Input
                                                        as="textarea"
                                                        rows={4}
                                                        placeholder="กรุณาระบุข้อความ"
                                                        defaultValue={this.state.committee1_comment}
                                                        onChange={e => this.setState({ committee1_comment: e })}
                                                    />
                                                </Col>
                                            </Row>
                                        </Panel>

                                        {/* ตารางคะแนนจากคณะกรรมการชุดที่ 2 */}
                                        <Panel
                                            className='mt-3'
                                            header={
                                                <>
                                                    <Text className='mb-2'>สรุปผลจากคณะกรรมการชุดที่ 2 :{' '}<Toggle
                                                        checkedChildren="ผ่าน"
                                                        unCheckedChildren="ไม่ผ่าน"
                                                        defaultChecked={this.state.committee2_result}
                                                        onChange={e => this.setState({ committee2_result: e })}
                                                        style={{ fontWeight: 'normal' }}
                                                    /></Text>
                                                </>
                                            }
                                            bordered
                                            style={{ padding: '8px' }}
                                        >

                                            <table
                                                style={{
                                                    width: "100%",
                                                    borderCollapse: "collapse",
                                                    marginBottom: "16px"
                                                }}
                                            >
                                                <thead>
                                                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                                                        <th style={{ width: "50px", border: "1px solid #ccc", padding: "8px", fontWeight: "bold", textAlign: "center", verticalAlign: "top" }}>ลำดับ</th>
                                                        <th style={{ width: "210px", border: "1px solid #ccc", padding: "8px", fontWeight: "bold", textAlign: "center", verticalAlign: "top" }}>รายชื่อคณะกรรมการ</th>
                                                        <th style={{ width: "90px", border: "1px solid #ccc", padding: "8px", fontWeight: "bold", textAlign: "center", verticalAlign: "top" }}>ลงคะแนน</th>
                                                        <th style={{ width: "425px", border: "1px solid #ccc", padding: "8px", fontWeight: "bold", textAlign: "center", verticalAlign: "top" }}>ข้อสังเกต/ข้อคิดเห็น</th>
                                                        <th style={{ width: "110px", border: "1px solid #ccc", padding: "8px", fontWeight: "bold", textAlign: "center", verticalAlign: "top" }}>คะแนน</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {dataWithAverage_2.map((row, index) => (
                                                        <tr key={index}>
                                                            <td style={{ width: "50px", border: "1px solid #ccc", padding: "8px", textAlign: "center", verticalAlign: "top" }}>{row.id}</td>
                                                            <td style={{ width: "210px", border: "1px solid #ccc", padding: "8px", verticalAlign: "top" }}>{row.name}</td>
                                                            <td style={{ width: "90px", border: "1px solid #ccc", padding: "8px", textAlign: "center", verticalAlign: "top" }}>
                                                                {row.isTotalRow ? (
                                                                    <strong>{row.vote}</strong>
                                                                ) : row.vote ? (
                                                                    <span style={{ color: "green" }}><i className="bi bi-check-lg"></i></span>
                                                                ) : (
                                                                    <span>&nbsp;</span>
                                                                )}
                                                            </td>
                                                            <td style={{ width: "425px", border: "1px solid #ccc", padding: "8px", wordBreak: "break-word", verticalAlign: "top" }}>{row.comment}</td>
                                                            <td style={{ width: "110px", border: "1px solid #ccc", padding: "8px", textAlign: "right", verticalAlign: "top" }}>
                                                                {row.isTotalRow ? <strong>{row.score}</strong> : row.score}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </Panel>
                                    </Panel>

                                    {/* งบประมาณ */}
                                    <Text
                                        className='mt-3'
                                        weight="bold"
                                        style={{
                                            backgroundColor: "rgb(138, 10, 10)",
                                            color: "white",
                                            padding: "8px 12px",
                                            borderRadius: "4px",
                                            display: "inline-block"
                                        }}
                                    >
                                        งบประมาณที่สนับสนุน (บาท)
                                    </Text>


                                    <Panel

                                        bordered
                                        style={{ padding: '12px' }}
                                    >
                                        <VStack className="mb-2">
                                            <label>ค่าครองชีพ</label>
                                            <InputNumber
                                                size="lg"
                                                defaultValue={this.state.cost_of_living}
                                                min={0}
                                                formatter={this.to2decimal}
                                                style={{ width: '50%' }}
                                                onChange={e => this.setState({ cost_of_living: e })}
                                            />
                                        </VStack>
                                        <VStack className="mb-2">
                                            <label>ค่าหลักสูตร</label>
                                            <InputNumber
                                                size="lg"
                                                defaultValue={this.state.tuition_fee}
                                                min={0}
                                                formatter={this.to2decimal}
                                                style={{ width: '50%' }}
                                                onChange={e => this.setState({ tuition_fee: e })}
                                            />
                                        </VStack>
                                        <VStack className="mb-2">
                                            <label>ค่าหอพัก</label>
                                            <InputNumber
                                                size="lg"
                                                defaultValue={this.state.dormitory}
                                                min={0}
                                                formatter={this.to2decimal}
                                                style={{ width: '50%' }}
                                                onChange={e => this.setState({ dormitory: e })}
                                            />
                                        </VStack>
                                        <VStack>
                                            <label>ค่าธรรมเนียมแรกเข้า</label>
                                            <InputNumber
                                                size="lg"
                                                defaultValue={this.state.registration}
                                                min={0}
                                                formatter={this.to2decimal}
                                                style={{ width: '50%' }}
                                                onChange={e => this.setState({ registration: e })}
                                            />
                                        </VStack>
                                    </Panel>
                                </Container>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button size="sm" appearance="primary" startIcon={<i className="bi bi-floppy-fill"></i>} onClick={() => this.onConfirm({ mode, id })}>
                                    บันทึก
                                </Button>
                                <Button size="sm" appearance="subtle" onClick={() => this.setState({ modal: null })}>
                                    ยกเลิก
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )
                });

            } catch (error) {
                console.error('Error loading data:', error);
                this.promisedSetState({ loading: false });
            }
        }
    };

    onModalCriteria = async ({ mode, sel }) => {
        if (mode !== 'setting') return;

        if (!sel) {
            this.promisedSetState({ loading: true });

            let committeeList_1 = [], committeeList_2 = [], scoringCriteria = [];

            try {
                const { defaultYear, authHeader } = this.state;

                const fetchData = async (url, mapFn) => {
                    const res = await axios.get(url, authHeader);
                    return Array.isArray(res.data) ? res.data.map(mapFn) : [];
                };

                const mapCommittee = suffix => item => ({
                    [`committeeId_${suffix}`]: item.id || Date.now() + Math.random(),
                    [`committeePath_${suffix}`]: item.path_key || null,
                    [`committeeRealId_${suffix}`]: item.id || null,
                    [`committeeName_${suffix}`]: item.name || '',
                    year: item.year || '',
                    status: null,
                });

                const mapCriteria = item => ({
                    criteriaId: item.id || Date.now() + Math.random(),
                    criteriaRealId: item.id || null,
                    criteriaName: item.details || '',
                    weight: item.weight || 0,
                    year: item.year || '',
                    status: null,
                });

                [committeeList_1, committeeList_2, scoringCriteria] = await Promise.all([
                    fetchData(
                        `${process.env.REACT_APP_API}/committee/year/${defaultYear}/1`,
                        mapCommittee(1)
                    ),
                    fetchData(
                        `${process.env.REACT_APP_API}/committee/year/${defaultYear}/2`,
                        mapCommittee(2)
                    ),
                    fetchData(
                        `${process.env.REACT_APP_API}/criteria/year/${defaultYear}`,
                        mapCriteria
                    ),
                ]);
            } catch (e) {
                console.error(e);
            }

            await this.promisedSetState({
                committeeList_1,
                committeeList_2,
                scoringCriteria,
                loading: false,
            });
        }

        /* ================= EditableCell ================= */
        const EditableCell = ({
            rowData,
            dataKey,
            rowDataKey,
            onChange,
            onEdit,
            type = 'string',
            tableType = 'criteria',
        }) => {
            const editing = rowData.status === 'EDIT';
            const value = rowData[dataKey] ?? '';
            const isNumber = type === 'number';

            const handleChange = val => {
                onChange(rowData[rowDataKey], dataKey, val);
            };

            const renderInput = () => {
                if (onEdit) onEdit();

                if (isNumber) {
                    return (
                        <InputNumber
                            size="sm"
                            defaultValue={value}
                            style={{ textAlign: 'center' }}
                            onChange={handleChange}
                        />
                    );
                }

                return tableType === 'criteria' ? (
                    <Input
                        as="textarea"
                        size="sm"
                        defaultValue={value}
                        onChange={handleChange}
                    />
                ) : (
                    <Input size="sm" defaultValue={value} onChange={handleChange} />
                );
            };

            return (
                <td
                    style={{
                        verticalAlign: 'top',
                        textAlign: isNumber ? 'center' : 'left'
                    }}
                >
                    {editing ? (
                        renderInput()
                    ) : (
                        <pre
                            style={{
                                margin: 0,
                                whiteSpace: 'pre-wrap',
                                textAlign: isNumber ? 'center' : 'left'
                            }}
                        >
                            {value}
                        </pre>
                    )}
                </td>
            );
        };

        /* ================= ActionCell ================= */
        const ActionCell = ({ rowData, rowDataKey, onEdit, onRemove }) => (
            <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                <HStack spacing={8} align="center">
                    {['committeeId_1', 'committeeId_2'].includes(rowDataKey) && (
                        <Button
                            appearance="primary"
                            color="blue"
                            size="sm"
                            startIcon={<i className="bi bi-check-circle-fill" />}
                            onClick={() => {
                                const pathKey =
                                    rowDataKey === 'committeeId_1'
                                        ? 'committeePath_1'
                                        : 'committeePath_2';
                                window.open(
                                    `${window.location.origin}/committee/${rowData[pathKey]}`,
                                    '_blank'
                                );
                            }}
                        >
                            ไปยังหน้าลงคะแนน
                        </Button>
                    )}

                    <IconButton
                        appearance="primary"
                        size="xs"
                        color={rowData.status === 'EDIT' ? 'blue' : 'yellow'}
                        icon={
                            rowData.status === 'EDIT'
                                ? <i className="bi bi-floppy-fill" />
                                : <i className="bi bi-pencil-square" />
                        }
                        onClick={() => {
                            onEdit(rowData[rowDataKey]);
                            this.onModalCriteria({ mode, sel: true });
                        }}
                    />

                    {onRemove && (
                        <IconButton
                            appearance="primary"
                            size="xs"
                            color="red"
                            icon={<i className="bi bi-trash-fill" />}
                            onClick={() => onRemove(rowData[rowDataKey])}
                        />
                    )}
                </HStack>
            </td>
        );

        /* ================= Handlers ================= */
        const updateList = (key, fn) => {
            const next = [...this.state[key]];
            fn(next);
            this.setState({ [key]: next });
        };

        const handleAdd = (key, item) => {
            this.setState(
                prev => ({ [key]: [...prev[key], { ...item, status: 'EDIT' }] }),
                () => this.onModalCriteria({ mode, sel: true })
            );
        };

        const handleEdit = (key, idKey, id) => {
            updateList(key, list =>
                list.forEach(i => {
                    if (i[idKey] === id)
                        i.status = i.status === 'EDIT' ? null : 'EDIT';
                })
            );
        };

        const handleChange = (key, idKey, id, field, val) => {
            updateList(key, list => {
                const item = list.find(i => i[idKey] === id);
                if (item) item[field] = val;
            });
        };

        const handleRemove = (key, idKey, id) => {
            this.setState(
                prev => ({ [key]: prev[key].filter(i => i[idKey] !== id) }),
                () => this.onModalCriteria({ mode, sel: true })
            );
        };

        const handleConditionalRemove = async ({ id, mode }) => {
            try {
                let res;

                if (mode === 'committee') {
                    res = await axios.get(
                        `${process.env.REACT_APP_API}/voting/committee/check/${id}`,
                        this.state.authHeader
                    );

                    if (res.data.used === true) {
                        await Swal.fire({
                            title: "ลบไม่ได้: รายชื่อนี้ได้ลงคะแนนแล้ว",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        return;
                    }

                    handleRemove('committeeList_1', 'committeeId_1', id);
                    handleRemove('committeeList_2', 'committeeId_2', id);
                }

                if (mode === 'criteria') {
                    res = await axios.get(
                        `${process.env.REACT_APP_API}/voting/criteria/${id}`,
                        this.state.authHeader
                    );

                    if (res.data.exists === true) {
                        await Swal.fire({
                            title: "ลบไม่ได้: เกณฑ์นี้กำลังถูกใช้งาน",
                            icon: "warning",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                        return;
                    }

                    handleRemove('scoringCriteria', 'criteriaId', id);
                }

            } catch (error) {
                console.error('เกิดข้อผิดพลาดในการตรวจสอบ:', error);
                await Swal.fire({
                    title: "เกิดข้อผิดพลาด: ไม่สามารถตรวจสอบสถานะการลบได้",
                    icon: "error",
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
            }
        };

        /* ================= Modal ================= */
        this.setState({
            modal: (
                <Modal open size="lg" onClose={() => this.setState({ modal: null })}>
                    <Modal.Header>
                        <Modal.Title>
                            รายชื่อคณะกรรมการและเกณฑ์การพิจารณาให้คะแนน
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        {/* ================= COMMITTEE 1 ================= */}
                        <Panel header={<Text weight="bold">รายชื่อคณะกรรมการชุดที่ 1</Text>}>
                            <Button
                                className="mb-2"
                                size="sm"
                                appearance="primary"
                                color="green"
                                startIcon={<i className="bi bi-plus-lg" />}
                                onClick={() =>
                                    handleAdd('committeeList_1', {
                                        committeeId_1: Date.now(),
                                        committeeRealId_1: null,
                                        committeeName_1: '',
                                    })
                                }
                            >
                                เพิ่มรายชื่อ
                            </Button>
                            <div style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered mb-0" style={{ minWidth: 500 }}>
                                    <thead>
                                        <tr>
                                            <th
                                                width={50}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                ลำดับ
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white'
                                                }}
                                            >
                                                รายชื่อ
                                            </th>
                                            <th
                                                width={260}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                ...
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.committeeList_1.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={3}
                                                    style={{
                                                        textAlign: 'center',
                                                        padding: '20px',
                                                        color: '#888'
                                                    }}
                                                >
                                                    กรุณาเพิ่มรายชื่อคณะกรรมการ
                                                </td>
                                            </tr>
                                        ) : (
                                            this.state.committeeList_1.map((r, i) => (
                                                <tr key={r.committeeId_1}>
                                                    <td align="center">{i + 1}</td>

                                                    <EditableCell
                                                        rowData={r}
                                                        dataKey="committeeName_1"
                                                        rowDataKey="committeeId_1"
                                                        tableType="committee_1"
                                                        onEdit={id =>
                                                            handleEdit('committeeList_1', 'committeeId_1', id)
                                                        }
                                                        onChange={(id, k, v) =>
                                                            handleChange('committeeList_1', 'committeeId_1', id, k, v)
                                                        }
                                                    />

                                                    <ActionCell
                                                        rowData={r}
                                                        rowDataKey="committeeId_1"
                                                        onEdit={id =>
                                                            handleEdit('committeeList_1', 'committeeId_1', id)
                                                        }
                                                        onRemove={id =>
                                                            handleConditionalRemove({ id, mode: 'committee' })
                                                        }
                                                    />
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Panel>

                        {/* ================= COMMITTEE 2 ================= */}
                        <Panel header={<Text weight="bold">รายชื่อคณะกรรมการชุดที่ 2</Text>}>
                            <Button
                                className="mb-2"
                                size="sm"
                                appearance="primary"
                                color="green"
                                startIcon={<i className="bi bi-plus-lg" />}
                                onClick={() =>
                                    handleAdd('committeeList_2', {
                                        committeeId_2: Date.now(),
                                        committeeRealId_2: null,
                                        committeeName_2: '',
                                    })
                                }
                            >
                                เพิ่มรายชื่อ
                            </Button>

                            <div style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered mb-0" style={{ minWidth: 500 }}>
                                    <thead>
                                        <tr>
                                            <th
                                                width={50}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                ลำดับ
                                            </th>

                                            <th
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white'
                                                }}
                                            >
                                                รายชื่อ
                                            </th>

                                            <th
                                                width={260}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                ...
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.committeeList_2.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={3}
                                                    style={{
                                                        textAlign: 'center',
                                                        padding: '20px',
                                                        color: '#888'
                                                    }}
                                                >
                                                    กรุณาเพิ่มรายชื่อคณะกรรมการ
                                                </td>
                                            </tr>
                                        ) : (
                                            this.state.committeeList_2.map((r, i) => (
                                                <tr key={r.committeeId_2}>
                                                    <td style={{ textAlign: 'center' }}>{i + 1}</td>

                                                    <EditableCell
                                                        rowData={r}
                                                        dataKey="committeeName_2"
                                                        rowDataKey="committeeId_2"
                                                        tableType="committee_2"
                                                        onEdit={id =>
                                                            handleEdit('committeeList_2', 'committeeId_2', id)
                                                        }
                                                        onChange={(id, k, v) =>
                                                            handleChange(
                                                                'committeeList_2',
                                                                'committeeId_2',
                                                                id,
                                                                k,
                                                                v
                                                            )
                                                        }
                                                    />

                                                    <ActionCell
                                                        rowData={r}
                                                        rowDataKey="committeeId_2"
                                                        onEdit={id =>
                                                            handleEdit('committeeList_2', 'committeeId_2', id)
                                                        }
                                                        onRemove={id =>
                                                            handleConditionalRemove({ id, mode: 'committee' })
                                                        }
                                                    />
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Panel>

                        {/* ================= CRITERIA ================= */}
                        <Panel header={<Text weight="bold">ตารางเกณฑ์การพิจารณาให้คะแนน</Text>}>
                            <Button
                                className="mb-2"
                                size="sm"
                                appearance="primary"
                                color="green"
                                startIcon={<i className="bi bi-plus-lg" />}
                                onClick={() =>
                                    handleAdd('scoringCriteria', {
                                        criteriaId: Date.now(),
                                        criteriaRealId: null,
                                        criteriaName: '',
                                        weight: 0,
                                    })
                                }
                            >
                                เพิ่มหัวข้อ
                            </Button>

                            <div style={{ overflowX: 'auto' }}>
                                <table className="table table-bordered mb-0" style={{ minWidth: 500 }}>
                                    <thead>
                                        <tr>
                                            <th
                                                width={50}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                ลำดับ
                                            </th>

                                            <th
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white'
                                                }}
                                            >
                                                หัวข้อการให้คะแนน
                                            </th>

                                            <th
                                                width={80}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                น้ำหนัก
                                            </th>

                                            <th
                                                width={100}
                                                style={{
                                                    backgroundColor: 'rgb(138,10,10)',
                                                    color: 'white',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                ...
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.scoringCriteria.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={4}
                                                    style={{
                                                        textAlign: 'center',
                                                        padding: '20px',
                                                        color: '#888'
                                                    }}
                                                >
                                                    กรุณาเพิ่มเกณฑ์การพิจารณา
                                                </td>
                                            </tr>
                                        ) : (
                                            this.state.scoringCriteria.map((r, i) => (
                                                <tr key={r.criteriaId}>
                                                    <td style={{ textAlign: 'center' }}>{i + 1}</td>

                                                    <EditableCell
                                                        rowData={r}
                                                        dataKey="criteriaName"
                                                        rowDataKey="criteriaId"
                                                        tableType="criteria"
                                                        onEdit={id =>
                                                            handleEdit('scoringCriteria', 'criteriaId', id)
                                                        }
                                                        onChange={(id, k, v) =>
                                                            handleChange(
                                                                'scoringCriteria',
                                                                'criteriaId',
                                                                id,
                                                                k,
                                                                v
                                                            )
                                                        }
                                                    />

                                                    <EditableCell
                                                        rowData={r}
                                                        dataKey="weight"
                                                        rowDataKey="criteriaId"
                                                        type="number"
                                                        onEdit={id =>
                                                            handleEdit('scoringCriteria', 'criteriaId', id)
                                                        }
                                                        onChange={(id, k, v) =>
                                                            handleChange(
                                                                'scoringCriteria',
                                                                'criteriaId',
                                                                id,
                                                                k,
                                                                v
                                                            )
                                                        }
                                                    />

                                                    <ActionCell
                                                        rowData={r}
                                                        rowDataKey="criteriaId"
                                                        onEdit={id =>
                                                            handleEdit('scoringCriteria', 'criteriaId', id)
                                                        }
                                                        onRemove={id =>
                                                            handleConditionalRemove({ id, mode: 'criteria' })
                                                        }
                                                    />
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </Panel>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button
                            appearance="primary"
                            size="sm"
                            startIcon={<i className="bi bi-floppy-fill" />}
                            onClick={() => this.onCommittee({ mode: 'insert' })}
                        >
                            บันทึก
                        </Button>
                        <Button
                            appearance="subtle"
                            size="sm"
                            onClick={() => this.setState({ modal: null })}
                        >
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            ),
        });
    };

    onCommittee = async ({ mode }) => {
        if (mode !== 'insert') return;

        try {
            const { committeeList_1, committeeList_2, scoringCriteria, authHeader, defaultYear } = this.state;

            // ✅ Validation
            if (committeeList_1.some(i => !i.committeeName_1?.trim()) ||
                committeeList_2.some(i => !i.committeeName_2?.trim())) {
                return Swal.fire({ title: "กรุณากรอกชื่อคณะกรรมการให้ครบถ้วน", icon: "warning", confirmButtonText: "ตกลง" });
            }
            if (scoringCriteria.some(i => !i.criteriaName?.trim())) {
                return Swal.fire({ title: "กรุณากรอกชื่อเกณฑ์การประเมินให้ครบถ้วน", icon: "warning", confirmButtonText: "ตกลง" });
            }

            const totalWeight = scoringCriteria.reduce((sum, i) => sum + Number(i.weight || 0), 0);
            if (totalWeight !== 100) {
                return Swal.fire({
                    title: "น้ำหนักรวมต้องเท่ากับ 100 เท่านั้น",
                    text: `น้ำหนักรวมปัจจุบัน: ${totalWeight}`,
                    icon: "warning",
                    confirmButtonText: "ตกลง",
                });
            }

            // 🧩 Map function
            const mapCommittee = (item, group) => group === 1
                ? item.committeeRealId_1 == null
                    ? { name: item.committeeName_1, year: defaultYear, groups: 1 }
                    : { id: item.committeeRealId_1, name: item.committeeName_1, year: defaultYear, groups: 1 }
                : item.committeeRealId_2 == null
                    ? { name: item.committeeName_2, year: defaultYear, groups: 2 }
                    : { id: item.committeeRealId_2, name: item.committeeName_2, year: defaultYear, groups: 2 };

            const mapCriteria = item => item.criteriaRealId == null
                ? { details: item.criteriaName, weight: item.weight, year: defaultYear }
                : { id: item.criteriaRealId, details: item.criteriaName, weight: item.weight, year: defaultYear };

            // 1️⃣ ส่ง committee ชุดที่ 1
            const res1 = await axios.post(`${process.env.REACT_APP_API}/committee`,
                committeeList_1.map(i => mapCommittee(i, 1)), authHeader);

            if (res1.data.message !== 'successfully' && res1.data.message !== 'No committees to save') {
                return Swal.fire({
                    title: "เกิดข้อผิดพลาดบันทึกคณะกรรมการชุดที่ 1",
                    text: res1.data.message || 'ไม่สามารถบันทึกข้อมูลได้',
                    icon: "error",
                    confirmButtonText: "ตกลง"
                });
            }

            // 2️⃣ ส่ง committee ชุดที่ 2
            const res2 = await axios.post(`${process.env.REACT_APP_API}/committee`,
                committeeList_2.map(i => mapCommittee(i, 2)), authHeader);

            if (res2.data.message !== 'successfully' && res2.data.message !== 'No committees to save') {
                return Swal.fire({
                    title: "เกิดข้อผิดพลาดบันทึกคณะกรรมการชุดที่ 2",
                    text: res2.data.message || 'ไม่สามารถบันทึกข้อมูลได้',
                    icon: "error",
                    confirmButtonText: "ตกลง"
                });
            }

            // 3️⃣ ส่ง scoring criteria
            const resC = await axios.post(`${process.env.REACT_APP_API}/criteria`,
                scoringCriteria.map(mapCriteria), authHeader);

            if (resC.data.message !== 'successfully' && resC.data.message !== 'No committees to save') {
                return Swal.fire({
                    title: "เกิดข้อผิดพลาดบันทึกเกณฑ์การประเมิน",
                    text: resC.data.message || 'ไม่สามารถบันทึกข้อมูลได้',
                    icon: "error",
                    confirmButtonText: "ตกลง"
                });
            }

            // ✅ สำเร็จ
            await this.onRenderContent({ mode: 'read' });
            await this.promisedSetState({ modal: null });

            Swal.fire({
                title: "คุณบันทึกข้อมูลเรียบร้อยแล้ว",
                icon: "success",
                timer: 2000,
                timerProgressBar: true,
                confirmButtonText: "ตกลง",
            });

        } catch (error) {
            if (error.response?.status === 401) window.location.href = '/admin/login';
            else Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                text: error.response?.data?.message || 'ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้',
                icon: 'error',
                confirmButtonText: 'ตกลง'
            });
        }
    };

    onConfirm = async ({ mode, id }) => {
        if (mode === 'consider') {
            const Response = await axios.put(`${process.env.REACT_APP_API}/decistion`, {
                id: id
                , decision_result: this.state.decision_result
                , committee1_result: this.state.committee1_result
                , committee1_comment: this.state.committee1_comment
                , committee2_result: this.state.committee2_result
                , cost_of_living: this.state.cost_of_living
                , tuition_fee: this.state.tuition_fee
                , dormitory: this.state.dormitory
                , registration: this.state.registration
            }, this.state.authHeader);

            const data = Response.data;

            if (data.message === 'successfully') {

                await this.onRenderContent({ mode: 'read' })

                await this.promisedSetState({ modal: null })

                Swal.fire({
                    title: "คุณแก้ไขข้อมูลเรียบร้อยแล้ว",
                    icon: "success",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });
            }
        } else if (mode === 'delete') {
            Swal.fire({
                title: "คุณต้องการลบใช่หรือไม่?",
                icon: "warning",
                showDenyButton: true,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                denyButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {

                    const Response = await axios.delete(`${process.env.REACT_APP_API}/application/${id}`, this.state.authHeader);

                    const data = Response.data;

                    if (data.message === 'successfully') {

                        await this.onRenderContent({ mode: 'read' })

                        Swal.fire({
                            title: "คุณลบข้อมูลเรียบร้อยแล้ว",
                            icon: "success",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    } else if (data.message === 'passed') {

                        await this.onRenderContent({ mode: 'read' })

                        Swal.fire({
                            title: "ไม่สามารถลบ เนื่องจากผ่านการคัดเลือกแล้ว",
                            icon: "error",
                            timer: 2000,
                            timerProgressBar: true,
                            confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                        });
                    }
                } else if (result.isDenied) {

                    await this.onRenderContent({ mode: 'read' })
                }
            });
        }
    }

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}